import ApiValues from '../url/apiurl'
import labels from '../../utils/constants/labels';
import Networking from '../../utils/api/apiaccess';
var axios = require('axios');
function getBasketPerformance(BasketID,Interval,BenchMarkID) {

    return Networking.GetApi(`${ApiValues.getBacketPerformance}basketId=${BasketID}&interval=${Interval}&benchMarkID=${BenchMarkID}`, "").then(result => { return result })
        .catch(function (error) {
            return { "status": "F", "message": labels.messages.apierror }
        });

}
export default getBasketPerformance
